// extracted by mini-css-extract-plugin
export default {"ListOfForumsRight":"qe_a","ListOfForumsRight__brandDaysPosts":"qe_b bhm_sw"};